import { MijnRoute } from '../../mijn-navigatie.model';

export const MORTGAGE_REDEEM: MijnRoute = {
    path: 'hypotheken-aflossen',
    navigationEvent: 'toHypothekenAflossen',
    regex: /^\/hypotheek\/hypotheken-aflossen$/,
    webcomponent: 'mijn-hypotheken-aflossen-webcomponent'
};
